import { DASHBOARD_MODES, DEFAULT_PROPS, EnvConfig, PARENT_ROUTE_NAMES, Props } from '@/models/common/env.model';
import { defineStore } from 'pinia';
import { usePermissionsStore } from '@/store/permissions.store';

export const useEnvStore = defineStore({
  id: 'env',
  state: (): EnvConfig => ({
    APP_MODE: '',
    MOCKS_ENABLED: '0',
    BACKOFFICE_API_URL: DEFAULT_PROPS().apiUrl,
    WL_SLUG: DEFAULT_PROPS().wlSlug,
    CURRENT_PARTENT_ROUTE_NAME: DEFAULT_PROPS().currentParentRouteName,
    MULTIBRAND_API_HOST: '',
    MULTIBRAND_API_URL: DEFAULT_PROPS().multibrandApiUrl,
    WHITELABEL_ID: '',
  }),
  actions: {
    setEnv(props: Props): void {
      this.APP_MODE = !!props.wlSlug && !!props.apiUrl
        ? DASHBOARD_MODES.BACKOFFICE
        : DASHBOARD_MODES.STANDALONE;
      this.setWlSlug(props.wlSlug || DEFAULT_PROPS().wlSlug);
      this.BACKOFFICE_API_URL = props.apiUrl || `${DEFAULT_PROPS().apiUrl}/${this.WL_SLUG}`;
      this.setServicePermissions(props.dashboardPermissions);
      this.setCurrentParentRouteName(props.currentParentRouteName);
      this.MULTIBRAND_API_HOST = props.multibrandApiUrl ? new URL(props.multibrandApiUrl).origin : '';
      this.MULTIBRAND_API_URL = props.multibrandApiUrl;
      this.setWhitelabelId(props.whitelabelId);
    },
    setWlSlug(wlSlug: string): void {
      this.WL_SLUG = wlSlug;
      this.updateBackofficeApiUrl();
    },
    updateBackofficeApiUrl(): void {
      this.BACKOFFICE_API_URL = `${DEFAULT_PROPS().apiUrl}/${this.WL_SLUG}`;
    },
    setServicePermissions(permissionsProp: string): void {
      const { setPermissions } = usePermissionsStore();
      setPermissions(JSON.parse(permissionsProp));
    },
    setCurrentParentRouteName(currentParentRouteName: PARENT_ROUTE_NAMES): void {
      this.CURRENT_PARTENT_ROUTE_NAME = currentParentRouteName;
    },
    setMetaTitle(title: string): void {
      const titleEl = document.querySelector('head title');

      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      titleEl!.textContent = (title);
    },
    setWhitelabelId(whitelabelId: string): void {
      this.WHITELABEL_ID = whitelabelId;
    },
  },
});
